import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import RecentFeed from './RecentFeed';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '300px',
    marginBottom: '30px',
    borderRadius: 'unset',
    padding: '20px'
  }
}));

const RecentFeedback = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <h3>Recent Feedback</h3>
      <RecentFeed
        date="March 10 - 09h55"
        feedback="New feedback from Fidelity"
      />
      <RecentFeed
        date="March 12 - 22h43"
        feedback="New feedback from Partech"
      />
    </Paper>
  );
};

export default RecentFeedback;
